import { setCompanyDetailsData } from '../../../redux/companyDetailsDataSlice';
import { EditcompanyContact } from '../companyContact/editcompanyContact';
import { AddcompanyContact } from '../companyContact/addcompanyContact';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { Box, Typography, Grid } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { DeleteRecord } from '../../deleteRecord';
import { useTranslation } from 'react-i18next';
import NullDataBox from '../../nullDataBox';
import Iconify from '../../Iconify';
import { useState } from 'react';
import axios from 'axios';
import '../../../css/sites/polesMetiersRelated.css';

const CompanyContactDetails = () => {

    const { t } = useTranslation();

    const dispatch = useDispatch();
    const CompanyDetailsData = useSelector((state) => state.CompanyDetailsData);
    const hasCompanyUpdatePermission = useHasPermission('entreprise_update');

    const [errMsg, setErrMsg] = useState('');
    const [openAddContact, setOpenAddContact] = useState(false);
    const [contactIdToDelete, setContactIdToDelete] = useState('');
    const [openDeleteContact, setOpenDeleteContact] = useState(false);
    const [contactToEdit, setContactToEdit] = useState({});
    const [openEditContact, setOpenEditContact] = useState(false);

    const handleDeleteOpen = (contactId) => {
        setContactIdToDelete(contactId);
        setOpenDeleteContact(true);
    }

    const handleEditContact = (contact) => {
        setContactToEdit(contact);
        setOpenEditContact(true);
    }

    const handleDeleteContact = async () => {
        try {
            const response = await axios.delete(`company-contact/${contactIdToDelete}`);
            if (response.status === 200 || response.status === 201) {
                setErrMsg('');
                setOpenDeleteContact(false);
                dispatch(setCompanyDetailsData({
                    ...CompanyDetailsData,
                    company_contact: CompanyDetailsData?.company_contact?.filter((contact) => contact?.id !== contactIdToDelete),
                }));
            }
        } catch (error) {
            setErrMsg(error.message || "Erreur lors de la suppression du contact");
            console.error('Error deleting company contact:', error);
            CustomErrorLogger(error, "Delete Company Contact");
        }
    };

    return (
        <Box className='siteRelations_box'>
            <Box className='siteRelations_edit_box'>
                <Typography className='siteRelations_title'>Contacts associés</Typography>
                {(hasCompanyUpdatePermission && CompanyDetailsData?.company_contact?.length > 0) &&
                    <Typography className='siteRelations_relation_ajouter' onClick={() => setOpenAddContact(true)}>+ Ajouter un contact</Typography>
                }
            </Box>

            {CompanyDetailsData?.company_contact?.length === 0 ?
                <NullDataBox
                    setOpenDialog={setOpenAddContact}
                    buttonTitle="Ajouter un contact"
                    description="Aucun contact associé à cette entreprise"
                />
                :
                <Box className='siteRelations_details_main_box'>
                    <Box className='siteRelations_details_actions_box'>
                        {CompanyDetailsData?.company_contact && CompanyDetailsData?.company_contact?.map(({ id, name, phone_number, email, post }) => (
                            <Box key={id} className='siteRelations_details_oneRelation_box'>
                                <Grid container>
                                    <Grid item xs={12} sm={12} lg={6} className='siteRelations_icon_title_response_box'>
                                        <Iconify icon="wpf:name" width="32px" />
                                        <Box className='siteRelations_response_box'>
                                            <Typography className='siteRelations_text_label'>Nom complet :</Typography>
                                            <Typography className='siteRelations_text_value'>{name}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} lg={6} className='siteRelations_icon_title_response_box'>
                                        <Iconify icon="mdi:telephone" width="32px" />
                                        <Box className='siteRelations_response_box'>
                                            <Typography className='siteRelations_text_label'>Téléphone :</Typography>
                                            <Typography className='siteRelations_text_value'>{phone_number || 'N/A'}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} lg={6} className='siteRelations_icon_title_response_box'>
                                        <Iconify icon="ic:baseline-email" width="32px" />
                                        <Box className='siteRelations_response_box'>
                                            <Typography className='siteRelations_text_label'>{t('email')} :</Typography>
                                            <Typography className='siteRelations_text_value'>{email || 'N/A'}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} lg={6} className='siteRelations_icon_title_response_box'>
                                        <Iconify icon="eos-icons:cluster-role" width="32px" />
                                        <Box className='siteRelations_response_box'>
                                            <Typography className='siteRelations_text_label'>Fonction :</Typography>
                                            <Typography className='siteRelations_text_value'>{post || 'N/A'}</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                                {hasCompanyUpdatePermission && (
                                    <Box className='siteRelations_relation_actions_box'>
                                        <Iconify
                                            className='siteRelations_action_icon'
                                            icon="ic:outline-delete"
                                            onClick={() => handleDeleteOpen(id)}
                                        />
                                        <Iconify
                                            className='siteRelations_action_icon'
                                            icon="ic:outline-edit"
                                            onClick={() => handleEditContact({ id, name, phone_number, email, post })}
                                        />
                                    </Box>
                                )}
                            </Box>
                        ))}
                    </Box>
                </Box>
            }

            {openAddContact &&
                <AddcompanyContact
                    openAddContact={openAddContact}
                    setOpenAddContact={setOpenAddContact}
                />
            }

            {openEditContact &&
                <EditcompanyContact
                    openEditContact={openEditContact}
                    setOpenEditContact={setOpenEditContact}
                    contactToEdit={contactToEdit}
                />
            }

            {openDeleteContact &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={openDeleteContact}
                    setOpenDelete={setOpenDeleteContact}
                    handleDelete={handleDeleteContact}
                    title="Êtes-vous sûr du vouloir supprimer ce contact ?"
                />
            }
        </Box>
    );
}

export default CompanyContactDetails;